export const SET_COORDINATOR = "SET_COORDINATOR";
